import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import CommonToast from "../../../../../components/_utils/CommonToast";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import RecreatePromptModalPopup from "../../../../../components/_utils/RecreatePromptModalPopup";
import {
  beneTxnDeniedApproval,
  beneTxnMultiDeniedApproval,
} from "../../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const BeneficiaryMultiApprovalFailed = () => {
  const { BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError } =
    useSelector((state) => state.beneTxnViewAccData);

  const [errorPageData, setErrorPageData] = useState([]);
  const [showRecreateModal, setShowRecreateModal] = useState(false);
  const [loadingBox, setLoadingBox] = useState(false);
  const [selectedTxnId, setSelectedTxnId] = useState("");
  const [allTxnBtn, setAllTxnBtn] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const navigationType = location.state?.type;

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedData"),
    );

    if (storedSelectedApproval) {
      setErrorPageData(storedSelectedApproval?.selectedSendTransactions);
    } else {
      setErrorPageData([]);
    }
  }, []);

  const findCommonNames = (arr1, arr2) => {
    if (!Array.isArray(arr2)) return arr1;

    const isStringError = arr2.some((item) => typeof item === "string");
    if (isStringError) return arr2;

    const arr2Map = new Map(arr2.map((item) => [item.id, item.errors]));
    return arr1
      .filter((item) => arr2Map.has(item.txn_id))
      .map((item) => ({
        ...item,
        errors: arr2Map.get(item.txn_id),
      }));
  };

  const filterErrorTxn = findCommonNames(
    errorPageData,
    JSON.parse(sessionStorage.getItem("selectedDataError")),
  );

  // recreate not in use that's button is disable and may be recreate functionality not proper
  const handleRecreateSingle = (id) => {
    setSelectedTxnId(id);
    setAllTxnBtn("");
    setShowRecreateModal(true);
  };

  const handleRecreateAll = () => {
    setAllTxnBtn("All-Txn");
    setShowRecreateModal(true);
  };

  const closeRecreateModal = () => {
    setShowRecreateModal(false);
  };

  const handleRecreationConfirmation = async (reason) => {
    setLoadingBox(true);
    let response;
    if (allTxnBtn === "All-Txn") {
      const allTxnIds = errorPageData
        ?.filter((txn) => txn.lifecycle_status !== "rejected")
        .map((txn) => txn.txn_id);

      response = await dispatch(
        beneTxnMultiDeniedApproval({
          id: allTxnIds,
          AccountIdData: reason,
        }),
      );

      if (response?.payload?.status) {
        CommonToast({
          text: "Transaction rejected and sent for recreation.",
          icon: ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK,
          variant: "var(--success)",
        });
        navigate(
          "/beneficiary_transaction_dashboard/multi_select/multi_approval/declined",
          { state: { type: "recreate_Multi" } },
        );
      }
    } else {
      response = await dispatch(
        beneTxnDeniedApproval({
          id: selectedTxnId ?? "",
          AccountIdData: reason,
        }),
      );

      if (response?.payload?.status) {
        const remainingtxns = errorPageData?.filter(
          (txn) => txn?.txn_id !== selectedTxnId,
        );
        setErrorPageData(remainingtxns);

        const storedData = JSON.parse(sessionStorage.getItem("selectedData"));
        if (storedData) {
          storedData.selectedSendTransactions = remainingtxns;
          sessionStorage.setItem("selectedData", JSON.stringify(storedData));
        }

        if (response?.payload?.status) {
          CommonToast({
            text: "Transaction rejected and sent for recreation.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });

          if (remainingtxns?.length === 0) {
            navigate(
              `/beneficiary_transaction_dashboard/beneficiary_transaction_view_all/beneficiary_transaction_detail_page/${selectedTxnId}`,
              { replace: true },
            );
          }
        }
      }

      setLoadingBox(false);
      setShowRecreateModal(false);
    }
  };

  const buttonRows = [
    [
      {
        btnText: "Send all for recreation",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: "https://q2pay.in/new_assets/common/detail_page/recreate_white.svg",
        imgColor: "var(--negative-bg)",
        handleFunction: handleRecreateAll,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "dark",
      },
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: () => navigate("/beneficiary_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  return (
    <>
      {showRecreateModal && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <RecreatePromptModalPopup
            onConfirmBtnClick={handleRecreationConfirmation}
            onClose={() => {
              setShowRecreateModal(false);
            }}
            onCancelBtnClick={() => {
              setShowRecreateModal(false);
            }}
          />
        </div>
      )}
      {/* {showRecreateModal && (
        <RecreatePromptModalPopup
          loadingBox={loadingBox}
          onConfirmBtnClick={handleRecreationConfirmation}
          onCancelBtnClick={closeRecreateModal}
        />
      )} */}

      <StatusContainer
        status="error"
        buttonRows={buttonRows}
        title={
          <>
            Oops!&nbsp;
            {BeneTxnMultiApprovalError
              ? "Transaction approval failed"
              : BeneTxnMultiDeniedApprovalError
                ? "Transaction rejection failed"
                : ""}
          </>
        }
        subtitle={
          navigationType === "recreate_Multi" ? (
            <span className="text-font-xs text-text-primary">
              An error occurred with the following transactions, causing the{" "}
              <br /> {BeneTxnMultiApprovalError ? "approval" : "rejection"}
              &nbsp;of all the transactions to fail.
            </span>
          ) : (
            <span className="text-font-xs text-text-primary">
              Approval of the transactions is not possible due to the following
              errors, their data can be used to recreate new ones.
            </span>
          )
        }
      >
        <>
          <TabsWeapperSection title="Error details">
            <>
              {Array.isArray(filterErrorTxn) &&
                filterErrorTxn.map((val, i) => {
                  if (typeof val === "string") {
                    return (
                      <InfoCard
                        key={i}
                        bgColor="var(--negative-card)"
                        rows={[
                          {
                            leftTitle: val,
                            leftSubTitle: "Error message",
                          },
                        ]}
                      />
                    );
                  }

                  return (
                    <>
                      {val?.errors?.map((error, index) => (
                        <InfoCard
                          key={`${i}-${index}`}
                          bgColor="var(--negative-card)"
                          rows={[
                            {
                              leftTitle: error?.reason || error,
                              leftSubTitle: "Error message",
                            },
                          ]}
                        />
                      ))}
                    </>
                  );
                })}
            </>
          </TabsWeapperSection>

          <TabsWeapperSection title="Transaction Details">
            <>
              {Array.isArray(errorPageData) &&
                errorPageData.map((val, i) => {
                  if (typeof val === "string") return null;

                  return (
                    <InfoCard
                      key={val?.txn_id || i}
                      bgColor="var(--negative-card)"
                      rows={[
                        {
                          leftTitle: val?.beneficiary_account_name
                            ?.toLowerCase()
                            ?.split(" ")
                            ?.map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1),
                            )
                            ?.join(" "),
                          leftSubTitle: "Beneficiary name",

                          rightText: true,
                          rightTitle: (
                            <>
                              INR <FormatAmount price={val?.amount} />
                            </>
                          ),
                          rightTitleTextColor: "var(--text-primary)",
                          rightTextFontWeight: "semibold",
                          rightSubTitle: "Amount",
                        },
                      ]}
                      button={true}
                      btnText="Send for recreation"
                      borderColor="var(--text-primary)"
                      outLineColor="var(--text-primary)"
                      fullWidthRequired={false}
                      enabledBgColor="var(--negative-card)"
                      enabledTextColor="var(--text-primary)"
                      textSemibold={false}
                      handleFunction={() => {
                        handleRecreateSingle(val?.txn_id);
                      }}
                      icon={ICONS?.ARROW_RIGHT_WHITE}
                      imgColor="var(--text-primary)"
                      iconToBeAlign="right"
                      isDisabled={false}
                    />
                  );
                })}
            </>
          </TabsWeapperSection>
        </>
      </StatusContainer>
    </>
  );
};

export default BeneficiaryMultiApprovalFailed;
